<template>
	<v-row>
		<v-dialog v-model="showDialog" :fullscreen="$vuetify.breakpoint.mobile" scrollable persistent no-click-animation 
		max-width="1150px" max-height="90%" style="z-index:20003;">
			<v-card>
				<v-card-title style="padding: 5px 0 0 5px;" :class="$vuetify.breakpoint.mobile ? 'fixNotchPaddingTop' : ''">
					<v-col v-if="!$vuetify.breakpoint.mobile" cols="12">
						<span style="font-size: 20px;">
							{{ !data.id ? $t('wkt.client.expensesheets.edit-dialog.new_title') : $t('wkt.client.expensesheets.edit-dialog.edit_title') }}
						</span>
						<!--<v-btn icon style="top: -20px; left: 10px; float: right;">
							<v-icon @click="close()">close</v-icon>
						</v-btn>-->
					</v-col>
					<v-col v-if="$vuetify.breakpoint.mobile" cols="12" class="pa-2 d-flex align-center">
						<v-btn icon @click="close()">
							<v-icon color="#185EA9">arrow_back</v-icon>
						</v-btn>
						<span style="font-size: 20px;">
							{{ !data.id ? $t('wkt.client.expensesheets.edit-dialog.new_title') : $t('wkt.client.expensesheets.edit-dialog.edit_title') }}
						</span>
					</v-col>
				</v-card-title>
				<v-skeleton-loader v-if="isLoading" type="table-tbody" class="my-4" />
				<!--<v-divider></v-divider>-->
				<v-card-text @wheel="onWheel" v-if="!isLoading">
					<v-form ref="form">
						<v-row>
							<v-col cols="12" style="padding-bottom: 0;">
								<v-text-field
								v-model="data.name"
								:label="$t('wkt.client.expensesheets.edit-dialog.name')"
								:placeholder="$t('wkt.client.expensesheets.edit-dialog.name_placeholder')"
								autocomplete="none"
								:rules="[validationRules.required]"
								max="255" 
							/>
							</v-col>
							<v-col cols="12" style="padding-bottom: 0;">
								<v-autocomplete
								v-model="data.projectId"
								:items="projects"
								item-text="shortName"
								item-value="id"
								:label="$t('wkt.client.expensesheets.edit-dialog.project')"
								:placeholder="$t('wkt.client.expensesheets.edit-dialog.project_placeholder')"
								menu-props="bottom, offsetY"
								/>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<!--<v-divider></v-divider>-->
				<v-card-actions v-if="!isLoading" :class="$vuetify.breakpoint.mobile ? 'fixNotchPaddingBottom' : ''">
				<v-btn v-if="data.id" text color="#ff0000" @click="confirmDelete()">{{ $t('wkt.client.common.dialog-buttons.delete') }}</v-btn>
				<v-spacer></v-spacer>
				<v-btn color="#185EA9" text @click="save()">{{ $t('wkt.client.common.dialog-buttons.save') }}</v-btn>
				<v-btn text @click="close()">{{ $t('wkt.client.common.dialog-buttons.cancel') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<ConfirmDialog ref="dlgConfirm"
			v-bind:title="$t('wkt.client.expensesheets.edit-window.confirm-delete-dialog.title')"
			v-bind:message="$t('wkt.client.expensesheets.edit-window.confirm-delete-dialog.text')"
			v-bind:titleOk="$t('wkt.client.common.dialog-buttons.delete')"
			v-bind:titleCancel="$t('wkt.client.common.dialog-buttons.cancel')"
			v-on:confirmed="deleteItem()"
		/>

	</v-row>	
</template>

<script>
import BaseModule from '../../common/BaseModule.js'
import ConfirmDialog from '../../common/ConfirmDialog'
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'

export default {
	name: 'EditExpenseSheetDialog',
	mixins: [BaseModule],
	components: {
		ConfirmDialog
	},
	data () {
		return {
			showDialog: false,
			isLoading: false,
			projects: [],
			data: {},
			msgCbUpdated: null,
			msgCbDeleted: null,
		}
	},
	methods: {
        onWheel(event) {
            event.stopPropagation();
        },
		open(id, msgCbUpdated, msgCbDeleted) {
			this.msgCbUpdated = msgCbUpdated;
			this.msgCbDeleted = msgCbDeleted;
			this.showDialog = true;

			this.projects = gwt.getSessionInformation().employeeProjects;
			
			if (!this.projects) {
				this.projects = [];
			} else {
				this.projects = this.projects.filter(p => p.enabled);
			}

			if (!id) {
				this.data = {
					companyId: gwt.getSessionInformation().company.id
				};

				if (this.$refs.form) {
					this.$refs.form.resetValidation();
				}
				return;
			}
				
			this.getExpenseSheetById(id);
		},
        close() {
            this.showDialog = false;
        },
		getExpenseSheetById(id) {
			this.isLoading = true;

			api.getExpenseSheetById(id,
				data => {
					this.isLoading = false;
                    this.data = data;

					if (this.$refs.form) {
						this.$refs.form.resetValidation();
					}
				},
				err => {
					this.isLoading = false;
					this.$log.error(err);
                    this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
				}
			);
		},
		save() {
			if (!this.$refs.form.validate()) {
				return;
			}

			this.isLoading = true;

			api.storeExpenseSheet(this.data,
				data => {
					this.isLoading = false;

					if (!data) {
						this.$emit('show-alert', { text: this.$t('wkt.client.expensesheets.edit-dialog.save_error'), color: 'error', timeout: 3000 });
						return;
					}

					this.showDialog = false;
						
					this.$emit('show-alert', { text: this.$t('wkt.client.expensesheets.edit-dialog.save_ok'), color: 'success', timeout: 3000 });
					
					if (this.msgCbUpdated) {
						this.msgCbUpdated(data);
					}                    
				},
				err => {
					this.isLoading = false;
					this.$log.error(err);
                    this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
				}
			);
		},
		confirmDelete() {
			this.$refs.dlgConfirm.confirm(this.data);
		},
		deleteItem() {	
			this.isLoading = true;	

			api.deleteExpenseSheetById(this.data.id,
				res => {
					this.isLoading = false;
					this.showDialog = false;
					if (res) {
						this.$emit('show-alert', { text: this.$t('wkt.client.expensesheets.edit-dialog.delete_ok'), color: 'success', timeout: 3000 });
					} else {
						this.$emit('show-alert', { text: this.$t('wkt.client.expensesheets.edit-dialog.delete_error'), color: 'error', timeout: 3000 });
					}
					if (this.msgCbDeleted) {
						this.msgCbDeleted();
					}
				},
				err => {
					this.isLoading = false;
					this.$log.error(err);
                    this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
				}
			);
		},

	},
}
</script>